import config from '../../config';
import OldFormatHelper from '../helpers/OldFormatHelper';

export default {
  getBasePriceText(product) {
    let response = ``;
    if(config.products.unitContentsIds.includes(product.unitContentsId)) {
      response = `${OldFormatHelper.getPrice(product.basePrice.brutto)} / ${product.basePrice.amount} ${product.basePrice.unit}`;
    }
    return response;
  },
  getMyFirstTimePrice() {
    if(!this.productInfo
      || !this.productInfo.prices
      || !this.productInfo.prices.customer
      || !this.productInfo.prices.customer.initialPurchase
      || !this.productInfo.prices.customer.initialPurchase.brutto) {
      return ``;
    }

    const price = this.isPartner ? this.productInfo.prices.partner.initialPurchase.brutto : this.productInfo.prices.customer.initialPurchase.brutto;

    return OldFormatHelper.getPrice(price);
  },
  getMyOriginalPrice() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.bruttoWithoutDiscount) {
      return ``;
    }

    const price = this.isPartner ? this.productInfo.prices.partner.bruttoWithoutDiscount : this.productInfo.prices.customer.bruttoWithoutDiscount;

    return OldFormatHelper.getPrice(price);
  },
  getMyPrice() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.brutto) {
      return ``;
    }

    const price = this.isPartner ? this.productInfo.prices.partner.brutto : this.productInfo.prices.customer.brutto;

    return OldFormatHelper.getPrice(price);
  },
  getMyPriceUnformatted() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.brutto) {
      return ``;
    }

    return this.isPartner ? this.productInfo.prices.partner.brutto : this.productInfo.prices.customer.brutto;
  },
  getPricePer1000g() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.brutto) {
      return ``;
    }

    return OldFormatHelper.getPrice(this.productInfo.basePrice.brutto);
  },
  getPricePer100ml() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.brutto) {
      return ``;
    }

    const price = this.isPartner ? this.productInfo.prices.partner.brutto : this.productInfo.prices.customer.brutto;

    const per100 = (price / this.productInfo.contentsAmount) * 100;

    return OldFormatHelper.getPrice(per100);
  },
  getPricePerCapsule() {
    if(!this.productInfo || !this.productInfo.prices || !this.productInfo.prices.customer || !this.productInfo.prices.customer.brutto) {
      return ``;
    }

    const price = this.isPartner ? this.productInfo.prices.partner.brutto : this.productInfo.prices.customer.brutto;

    const per1 = (price / this.productInfo.contentsAmount);

    return OldFormatHelper.getPrice(per1);
  },
  hasBasePrice(product) {
    for(const key of Object.keys(product.basePrice)) {
      if(product.basePrice[key] === null) {
        return false;
      }
    }
    return true;
  },
};
